import React from 'react'

import { StyledLineDivider } from './LineDivider.styled'

export const LineDivider = () => <StyledLineDivider />
